<div class="section-footnotes">
  <p *ngFor="let footnote of footnotes" [innerHTML]=footnote></p>
</div>